import { render, staticRenderFns } from "./ProviderShows.vue?vue&type=template&id=21ab45ae&lang=pug&"
import script from "./ProviderShows.vue?vue&type=script&lang=js&"
export * from "./ProviderShows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports